export default __webpack_public_path__ + "static/media/cert_ferry.720c9a67.jpg";